export default {
  init() {
    let canReload;
    let mgs_videos = document.querySelector("iframe[src^='https://www.youtube.com']");
    let mgs_videos2 = document.querySelector("iframe[src^='https://www.youtube-nocookie.com']");

    (mgs_videos || mgs_videos2) ? canReload = false : canReload = true;

    // console.log('***', mgs_videos);
    // console.log('***', mgs_videos2);
    console.log('*** Reload: ' + canReload);
    // console.log((mgs_videos) ? 'existe' : 'Não existe');
    this.refresh(canReload);
  },
  refresh(canReload) {
    // if((location.host == 'www.maisgoias.com.br' || location.host == 'localhost:3000') && canReload) {
    if (location.host == 'www.maisgoias.com.br' && canReload) {
      console.log('*** Refresh active');
      setTimeout(function () {
        location.reload()
      }, 150000);
    }
  }
};